// @flow
import RateConversationActionTypes from '../action-types/rate-conversation';

export interface State {
  conversationStatus: Object;
  isOpen: boolean;
  rate?: number;
  rateHover?: number;
  hostName: string;
}

const INITIAL_STATE = {
  conversationStatus: {},
  isOpen: false,
  rate: undefined,
  rateHover: undefined,
  hostName: '',
};

// $FlowFixMe
const rateConversationReducer = (state: State = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case RateConversationActionTypes.CLEAR_CONVERSATION_STATUS:
      return {
        ...state,
        conversationStatus: {},
      };
    case RateConversationActionTypes.SET_CONVERSATION_STATUS:
      return {
        ...state,
        conversationStatus: action.payload,
      };
    case RateConversationActionTypes.SET_RATE_CONVERSATION_OPEN:
      return {
        ...state,
        isOpen: action.payload,
      };
    case RateConversationActionTypes.SET_RATE:
      return {
        ...state,
        rate: action.payload,
      };
    case RateConversationActionTypes.SET_RATE_HOVER:
      return {
        ...state,
        rateHover: action.payload,
      };
    case RateConversationActionTypes.SET_HOST_NAME:
      return {
        ...state,
        hostName: action.payload,
      };
    default:
      return state;
  }
};

export default rateConversationReducer;
